import { MegaphoneIcon, XIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import {
  DetailsSectionSubtitle,
  DetailsSectionTitle,
  IconBubble,
  IconButton,
  Popover,
  PopoverAnchor,
  PopoverContent,
} from '../../../../core'
import { useAnnouncementsMenuHintContext } from '../AnnouncementsMenuHintContext'

export interface AnnouncementsMenuHintPopoverProps {
  children: ReactNode
}

export function AnnouncementsMenuHintPopover({
  children,
}: AnnouncementsMenuHintPopoverProps) {
  const hint = useAnnouncementsMenuHintContext()
  const isOpen = hint.state.isHintVisible

  const handleOpenChange = (open: boolean) => {
    if (open === false) {
      hint.actions.dismissHint()
    }
  }

  return (
    <Popover open={isOpen} onOpenChange={handleOpenChange}>
      <PopoverAnchor asChild>{children}</PopoverAnchor>
      <PopoverContent
        align="end"
        sideOffset={4}
        size="sm"
        variant="plain"
        onOpenAutoFocus={(event) => {
          event.preventDefault()
        }}
      >
        <div className="relative flex flex-col items-start gap-y-2 rounded-md border border-blue-500/30 bg-blue-50 p-4 text-blue-800 shadow-xl dark:bg-blue-950 dark:text-blue-400">
          <span className="absolute top-2 right-2">
            <IconButton
              variant="ghost"
              size="xs"
              tooltip="Dismiss"
              onClick={() => {
                hint.actions.dismissHint()
              }}
            >
              <XIcon className="size-3.5" />
            </IconButton>
          </span>

          <header className="flex items-center gap-x-2">
            <IconBubble variant="info" size="sm">
              <MegaphoneIcon />
            </IconBubble>

            <div className="text-blue-800 dark:text-blue-400">
              <DetailsSectionTitle size="sm" tone="inherit">
                {`Missed something?`}
              </DetailsSectionTitle>
            </div>
          </header>

          <div className="text-blue-700 dark:text-blue-400/80">
            <DetailsSectionSubtitle size="xs" tone="inherit">
              {`You can revisit announcements anytime from your profile menu under "Help".`}
            </DetailsSectionSubtitle>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
